<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-12">
              <div class="media">
                <div class="avatar sm">
                  <a href="index.html" title="" class="link"><i class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h6 class="fw-bold text-truncate mb-0 me-auto">Settings</h6>
                  </div>
                  <div class="text-truncate">Last Update your profile: 29 Aug 2020</div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- Tab: Account setting-->
          <div class="row">
            <div class="col-12">
              <ul class="nav nav-tabs nav-overflow page-header-tabs mb-4 mt-md-5 mt-3">
                <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                    [ngClass]="{'active': genralTab}">General</a></li>
                <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                    [ngClass]="{'active': billTab}">Billing</a></li>
                <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('3')"
                    [ngClass]="{'active': memberTab}">Members</a></li>
                <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('4')"
                    [ngClass]="{'active': secureTab}">Security</a></li>
                <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('5')"
                    [ngClass]="{'active': faqTab}">FAQs</a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Tab content: Account setting-->
          <div class="tab-content">

            <!-- general-->
            <div class="tab-pane fade show active" id="setting-general" role="tabpanel"
              [ngClass]="{'show active': genralTab}">

              <div class="row">
                <div class="col-12">
                  <div class="card mb-4">
                    <div class="card-header">
                      <h6 class="card-title mb-0">Account Setting</h6>
                      <span class="text-muted small">Update your account details</span>
                    </div>
                    <div class="card-body">

                      <!-- setting: Account Setting input-->
                      <form class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg" placeholder="Enter your name">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg" placeholder="Enter phone">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg" placeholder="Enter your email">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg"
                                placeholder="Facebook profile link">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg"
                                placeholder="Instagram profile link">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control form-control-lg"
                                placeholder="Linkedin profile link">
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label>Select Avatar</label>
                            <input type="file" class="form-control-file">
                          </div>

                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <div class="input-group">
                              <textarea rows="4" class="form-control" placeholder="Enter Bio"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <button type="button" class="btn btn-primary">Update Details</button>
                          <button type="button" class="btn btn-link">Cancel</button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between mt-4">
                <div class="col-12 col-md-6">
                  <h5>Delete your account</h5>
                  <p class="text-muted mb-md-0">Please note, deleting your account is a permanent action and will no be
                    recoverable once completed.</p>
                </div>
                <div class="col-auto">
                  <button class="btn btn-danger">Delete</button>
                </div>
              </div>

            </div>

            <!-- billing -->
            <div class="tab-pane fade" id="setting-billing" role="tabpanel" [ngClass]="{'show active': billTab}">
              <div class="row">

                <div class="col-12">
                  <div class="alert alert-danger">
                    <i class="zmdi zmdi-info me-1"></i> You are near your API limits.
                  </div>
                </div>

                <div class="col-12 col-md-6">

                  <!-- Card -->
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col">
                          <h6 class="text-uppercase text-muted mb-1 small">Current plan</h6>
                          <span class="h3 mb-0">$39/mo</span>
                        </div>
                        <div class="col-auto">
                          <a class="btn btn-sm btn-dark" [routerLink]="['/pricing']"
                            href="javascript:void(0)">Upgrade</a>
                        </div>
                      </div> <!-- row end -->

                    </div>
                  </div>

                </div>

                <div class="col-12">
                  <!-- Card: -->
                  <div class="card mb-4">
                    <div class="card-header">
                      <div class="row align-items-center">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="card-title mb-0">Payment methods</h6>
                        </div>
                        <div class="col-auto">
                          <!-- Button -->
                          <a class="btn btn-sm btn-primary" href="javascript:void(0)!">Add method</a>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">

                      <!-- List group -->
                      <div class="list-group custom list-group-flush my-2">
                        <div class="list-group-item">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <img class="img-fluid" src="assets/images/visa.svg" alt="..." style="max-width: 38px;">
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-0">Visa ending in 2222</h6>
                              <small class="text-muted">Expires 05/2023</small>
                            </div>

                            <div class="col-auto mr-n3">
                              <span class="badge bg-light text-dark">Default</span>
                            </div>

                            <!-- Dropdown -->
                            <div class="col-auto">

                              <div class="dropdown" dropdown placement="bottom right">
                                <a id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                                  class="dropdown-ellipses dropdown-toggle">
                                  <i class="zmdi zmdi-more"></i>
                                </a>
                                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                                </div>
                              </div>

                            </div>

                          </div> <!-- row end -->
                        </div>
                        <div class="list-group-item">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <img class="img-fluid" src="assets/images/mastercard.svg" alt="..."
                                style="max-width: 38px;">
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-0">Mastercard ending in 9999</h6>
                              <small class="text-muted">Expires 10/2026</small>
                            </div>

                            <!-- Dropdown -->
                            <div class="col-auto">
                              <div class="dropdown" dropdown placement="bottom right">
                                <a id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                                  class="dropdown-ellipses dropdown-toggle">
                                  <i class="zmdi zmdi-more"></i>
                                </a>
                                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                                </div>
                              </div>
                            </div>

                          </div> <!-- row end -->
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- Card: -->
                  <div class="card">
                    <div class="card-body">
                      <h6 class="card-title mb-0">Invoices</h6>
                    </div>

                    <div class="table-responsive">
                      <table class="table table-border table-hover table-nowrap card-table mb-0">
                        <thead>
                          <tr>
                            <th>Invoice ID</th>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody class="font-size-base">
                          <tr>
                            <td>
                              <a [routerLink]="['/invoices']" href="javascript:void(0)">Invoice #10022</a>
                            </td>
                            <td>
                              <time datetime="2020-04-24">Oct. 24, 2020</time>
                            </td>
                            <td>
                              $29.00
                            </td>
                            <td>
                              <span class="badge bg-secondary">Outstanding</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <a [routerLink]="['/invoices']" href="javascript:void(0)">Invoice #10012</a>
                            </td>
                            <td>
                              <time datetime="2020-03-24">Aug. 11, 2020</time>
                            </td>
                            <td>
                              $29.00
                            </td>
                            <td>
                              <span class="badge bg-success">Paid</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <a [routerLink]="['/invoices']" href="javascript:void(0)">Invoice #10043</a>
                            </td>
                            <td>
                              <time datetime="2020-02-24">July. 5, 2020</time>
                            </td>
                            <td>
                              $29.00
                            </td>
                            <td>
                              <span class="badge bg-success">Paid</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <a [routerLink]="['/invoices']" href="javascript:void(0)">Invoice #10045</a>
                            </td>
                            <td>
                              <time datetime="2020-01-24">Jun. 16, 2020</time>
                            </td>
                            <td>
                              $29.00
                            </td>
                            <td>
                              <span class="badge bg-success">Paid</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div> <!-- row end -->

              <p class="mt-4">
                <small class="text-muted">Don’t need Dashkit anymore? <a href="javascript:void(0)!">Cancel your
                    account</a></small>
              </p>
            </div>

            <!-- members -->
            <div class="tab-pane fade" id="setting-members" role="tabpanel" [ngClass]="{'show active': memberTab}">
              <div class="row">
                <div class="col-12 col-md-6">

                  <!-- Card -->
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col">
                          <p class="text-uppercase text-muted small mb-1">Seats used</p>
                          <span class="h4 mb-0">4 out of 6</span>
                        </div>
                        <div class="col-auto">
                          <a class="btn btn-sm btn-outline-primary" href="javascript:void(0)!">Upgrade</a>
                        </div>
                      </div> <!-- row end -->

                    </div>
                  </div>

                </div>
                <div class="col-12 col-md-6">

                  <!-- Card -->
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col">
                          <p class="text-uppercase text-muted small mb-1">Default role</p>
                          <span class="h4 mb-0">Staff</span>
                        </div>
                        <div class="col-auto">
                          <a class="btn btn-sm btn-dark" href="javascript:void(0)!">Change</a>
                        </div>
                      </div> <!-- row end -->

                    </div>
                  </div>

                </div>
              </div> <!-- row end -->

              <div class="row">
                <div class="col-12">

                  <!-- Card -->
                  <div class="card">
                    <div class="card-header d-flex justify-content-between">
                      <h6 class="card-title">Members</h6>

                      <!-- Dropdown -->

                      <div class="dropdown" dropdown placement="bottom right">
                        <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                          class="btn btn-sm btn-primary dropdown-toggle">
                          Invite member
                        </button>

                        <form id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-basic" style="width: 300px;">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Invite a member</h6>
                            <span class="badge bg-primary">2 seats left</span>
                          </div>
                          <div class="card-header">
                            <div class="row no-gutters align-items-center">
                              <div class="col-3">
                                <label class="mb-0">Name</label>
                              </div>
                              <div class="col">
                                <input class="form-control form-control-flush" type="text" placeholder="Full name">
                              </div>
                            </div> <!-- row end -->
                          </div>
                          <div class="card-header">
                            <div class="row no-gutters align-items-center">
                              <div class="col-3">
                                <label class="mb-0">Email</label>
                              </div>
                              <div class="col">
                                <input class="form-control form-control-flush" type="text" placeholder="Email address">
                              </div>
                            </div> <!-- row end -->
                          </div>
                          <div class="card-footer">

                            <!-- Button -->
                            <button class="btn btn-block btn-primary" type="submit">
                              Invite member
                            </button>

                          </div>
                        </form>

                      </div>

                    </div>
                    <div class="card-body">

                      <!-- List group -->
                      <div class="list-group custom list-group-flush my-md-3">
                        <div class="list-group-item">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar1.jpg"
                                  alt="..." class="avatar rounded-circle"></a>
                            </div>
                            <div class="col-5 ms-2">
                              <h6 class="mb-1"><a href="javascript:void(0)">Dianna Smiley</a></h6>
                              <p class="small text-muted mb-0">
                                <a class="d-block text-reset text-truncate"
                                  href="mailt:amelia.green@company.com">amelia.green@company.com</a>
                              </p>
                            </div>
                            <div class="col-auto ms-auto mr-md-3">
                              <select class="form-control custom-select" data-bs-toggle="select">
                                <option value="1">Admin</option>
                                <option value="2">Staff</option>
                                <option value="3">Custom</option>
                              </select>
                            </div>
                            <div class="col-auto">
                              <div class="dropdown" dropdown placement="bottom right">
                                <a id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                                  class="dropdown-ellipses dropdown-toggle">
                                  <i class="zmdi zmdi-more"></i>
                                </a>
                                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                                </div>
                              </div>
                            </div>
                          </div> <!-- row end -->

                        </div>
                        <div class="list-group-item">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar2.jpg"
                                  alt="..." class="avatar rounded-circle"></a>
                            </div>
                            <div class="col-5 ms-2">
                              <h6 class="mb-1"><a href="javascript:void(0)">Dianna Smiley</a></h6>
                              <p class="small text-muted mb-0">
                                <a class="d-block text-reset text-truncate"
                                  href="mailt:charlotte.green@company.com">charlotte.green@company.com</a>
                              </p>
                            </div>
                            <div class="col-auto ms-auto mr-md-3">
                              <select class="form-control custom-select" data-bs-toggle="select">
                                <option value="1">Admin</option>
                                <option value="2">Staff</option>
                                <option value="3">Custom</option>
                              </select>
                            </div>
                            <div class="col-auto">
                              <div class="dropdown" dropdown placement="bottom right">
                                <a id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                                  class="dropdown-ellipses dropdown-toggle">
                                  <i class="zmdi zmdi-more"></i>
                                </a>
                                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                                </div>
                              </div>
                            </div>
                          </div> <!-- row end -->

                        </div>
                        <div class="list-group-item">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar3.jpg"
                                  alt="..." class="avatar rounded-circle"></a>
                            </div>
                            <div class="col-5 ms-2">
                              <h6 class="mb-1"><a href="javascript:void(0)">Dianna Smiley</a></h6>
                              <p class="small text-muted mb-0">
                                <a class="d-block text-reset text-truncate"
                                  href="mailt:susie.willis@company.com">susie.willis@company.com</a>
                              </p>
                            </div>
                            <div class="col-auto ms-auto mr-md-3">
                              <select class="form-control custom-select" data-bs-toggle="select">
                                <option value="1">Admin</option>
                                <option value="2">Staff</option>
                                <option value="3">Custom</option>
                              </select>
                            </div>
                            <div class="col-auto">
                              <div class="dropdown" dropdown placement="bottom right">
                                <a id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                                  class="dropdown-ellipses dropdown-toggle">
                                  <i class="zmdi zmdi-more"></i>
                                </a>
                                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                                </div>
                              </div>
                            </div>
                          </div> <!-- row end -->

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div> <!-- row end -->
            </div>

            <!-- security -->
            <div class="tab-pane fade" id="setting-security" role="tabpanel" [ngClass]="{'show active': secureTab}">
              <div class="row justify-content-between mb-4">
                <div class="col-12 col-md-6">
                  <h5>Change your password</h5>
                  <p class="text-muted mb-md-0">We will email you a confirmation when changing your password, so please
                    expect that email after submitting.</p>
                </div>
                <div class="col-auto">
                  <button class="btn btn-warning">Forgot your password?</button>
                </div>
              </div> <!-- row end -->
              <div class="row">
                <div class="col-12">
                  <!-- Card: -->
                  <div class="card mb-4">
                    <div class="card-body">
                      <form class="row">
                        <div class="col-lg-4 col-md-12">
                          <div class="form-group">
                            <label>Current password</label>
                            <input type="email" class="form-control">
                          </div>
                          <div class="form-group">
                            <label>New password</label>
                            <input type="email" class="form-control">
                          </div>
                          <div class="form-group">
                            <label>Confirm password</label>
                            <input type="email" class="form-control">
                          </div>
                          <button type="button" class="btn btn-primary">Update Password</button>
                          <button type="button" class="btn btn-link">Cancel</button>
                        </div>
                        <div class="col-lg-8 col-md-12">
                          <!-- Card: -->
                          <div class="card bg-light text-dark border">
                            <div class="card-body">
                              <p class="mb-2">Password requirements</p>
                              <p class="small text-muted mb-2">To create a new password, you have to meet all of the
                                following requirements:</p>

                              <!-- List group -->
                              <ul class="small text-muted ps-4 mb-0">
                                <li>Minimum 8 character</li>
                                <li>At least one special character</li>
                                <li>At least one number</li>
                                <li>Can’t be the same as a previous password</li>
                              </ul>

                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div> <!-- row end -->
              <div class="row justify-content-between mt-4 mb-4">
                <div class="col-12 col-md-6">
                  <h5>Device History</h5>
                  <p class="text-muted mb-md-0">If you see a device here that you believe wasn’t you, please contact our
                    account fraud department immediately.</p>
                </div>
                <div class="col-auto">
                  <button class="btn btn-dark">Log out all devices</button>
                </div>
              </div> <!-- row end -->
              <div class="row">
                <div class="col-12">
                  <!-- Card: -->
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="list-group custom list-group-flush my-md-3">
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <div class="avatar lg text-center"><i class="zmdi zmdi-smartphone h2"></i></div>
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-1">iPhone 11</h6>
                              <small class="text-muted">Brownsville, VT · <time>Jun 11 at 10:05am</time></small>
                            </div>
                            <div class="col-auto">
                              <button class="btn btn-sm btn-white">Sign out</button>
                            </div>
                          </div>
                        </div>
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <div class="avatar lg text-center"><i class="zmdi zmdi-desktop-mac h2"></i></div>
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-1">iMac OSX · <span class="font-weight-normal">Safari 10.2</span></h6>
                              <small class="text-muted">Ct, Corona, CA · <time>September 14 at 2:30pm</time></small>
                            </div>
                            <div class="col-auto">
                              <button class="btn btn-sm btn-white">Sign out</button>
                            </div>
                          </div>
                        </div>
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <div class="avatar lg text-center"><i class="zmdi zmdi-laptop h2"></i></div>
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-1">HP Laptop Win10</h6>
                              <small class="text-muted">Ct, Corona, CA · <time>September 16 at 11:16am</time></small>
                            </div>
                            <div class="col-auto">
                              <button class="btn btn-sm btn-white">Sign out</button>
                            </div>
                          </div>
                        </div>
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <div class="avatar lg text-center"><i class="zmdi zmdi-desktop-windows h2"></i></div>
                            </div>
                            <div class="col ml-n2">
                              <h6 class="mb-1">iMac OSX · <span class="font-weight-normal">Edge browser</span></h6>
                              <small class="text-muted">Huntington Station, NY · <time>October 26 at
                                  5:16pm</time></small>
                            </div>
                            <div class="col-auto">
                              <button class="btn btn-sm btn-white">Sign out</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> <!-- row end -->
            </div>

            <!-- faqs -->
            <div class="tab-pane fade" id="setting-faqs" role="tabpanel" [ngClass]="{'show active': faqTab}">
              <div class="row">
                <div class="col-lg-3 col-md-12">
                  <div class="mb-4">
                    <h6>Useful tips</h6>
                    <p class="text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                      nibh
                      euismod tincidunt.</p>
                    <div class="list-group custom">
                      <a class="list-group-item" href="javascript:void(0)"><i
                          class="zmdi zmdi-circle small me-2 text-danger"></i>Lorem
                        ipsum</a>
                      <a class="list-group-item" href="javascript:void(0)"><i
                          class="zmdi zmdi-circle small me-2 text-info"></i>Consectetuer adipiscing</a>
                      <a class="list-group-item" href="javascript:void(0)"><i
                          class="zmdi zmdi-circle small me-2 text-primary"></i>Sed
                        diam
                        nonummy</a>
                      <a class="list-group-item" href="javascript:void(0)"><i
                          class="zmdi zmdi-circle small me-2 text-warning"></i>Euismod
                        tincidunt</a>
                    </div>
                  </div>

                  <div class="mb-3">
                    <h6>Can't find the answer? </h6>
                    <p class="text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                      nibh
                      euismod tincidunt.</p>
                    <a href="javascript:void(0)" class="btn btn-primary">Contact us</a>
                  </div>
                </div>

                <div class="col-lg-9 col-md-12">
                  <!-- Card: -->
                  <div class="card">
                    <div class="card-body">
                      <h6>General</h6>
                      <div id="demo-gen-faq" class="accordion border-bottom mb-4">
                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isgenCollapsed = !isgenCollapsed"
                              [attr.aria-expanded]="!isgenCollapsed" aria-controls="collapseBasic">Lorem ipsum dolor sit
                              amet
                              ?</a>
                            <div id="collapseBasic" [collapse]="isgenCollapsed" [isAnimated]="true" class="collapse in">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed2 = !isCollapsed2"
                              [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseBasic2">Consectetuer
                              adipiscing
                              elit ?</a>
                            <div id="collapseBasic2" [collapse]="isCollapsed2" [isAnimated]="true" class="in py3
                                            collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed3 = !isCollapsed3"
                              [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseBasic3">Sed diam
                              nonummy nibh euismod tincidunt ?</a>
                            <div id="collapseBasic3" [collapse]="isCollapsed3" [isAnimated]="true" class="in py3
                                                                      collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.

                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed4 = !isCollapsed4"
                              [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseBasic4">Tincidunt ut laoreet
                              dolore magna ?</a>
                            <div id="collapseBasic4" [collapse]="isCollapsed4" [isAnimated]="true" class="in py3
                                                                      collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->
                      </div>

                      <!-- ACCOUNT -->
                      <h6>Account</h6>
                      <div id="demo-acc-faq" class="accordion mb-4">
                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed5 = !isCollapsed5"
                              [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseBasic5">Lorem ipsum dolor sit
                              amet
                              ?</a>
                            <div id="collapseBasic5" [collapse]="isCollapsed5" [isAnimated]="true" class="in py3
                                                                                            collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed6 = !isCollapsed6"
                              [attr.aria-expanded]="!isCollapsed6" aria-controls="collapseBasic6">Consectetuer
                              adipiscing
                              elit ?</a>
                            <div id="collapseBasic6" [collapse]="isCollapsed6" [isAnimated]="true"
                              class="in py3
                                                                                                                      collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed7 = !isCollapsed7"
                              [attr.aria-expanded]="!isCollapsed7" aria-controls="collapseBasic7">Sed diam nonummy nibh
                              euismod tincidunt ?</a>
                            <div id="collapseBasic7" [collapse]="isCollapsed7" [isAnimated]="true"
                              class="in py3
                                                                                                                                                  collapse">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->
                      </div>

                      <!-- PAYMENT -->
                      <h6 class="pad-all bord-btm text-thin">Payment</h6>
                      <div id="demo-pym-faq" class="accordion">
                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed8 = !isCollapsed8"
                              [attr.aria-expanded]="!isCollapsed8" aria-controls="collapseBasic8">Lorem ipsum dolor
                              sit amet ?</a>
                            <div id="collapseBasic8" [collapse]="isCollapsed8" [isAnimated]="true" class="collapse in">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed9 = !isCollapsed9"
                              [attr.aria-expanded]="!isCollapsed9" aria-controls="collapseBasic9">Consectetuer
                              adipiscing elit ?</a>
                            <div id="collapseBasic9" [collapse]="isCollapsed9" [isAnimated]="true" class="collapse in">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed10 = !isCollapsed10"
                              [attr.aria-expanded]="!isCollapsed10" aria-controls="collapseBasic10">Sed diam nonummy
                              nibh euismod tincidunt ?</a>
                            <div id="collapseBasic10" [collapse]="isCollapsed10" [isAnimated]="true"
                              class="collapse in">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                        <div class="mb-1">
                          <div class="py-2 px-3 bg-light text-dark">
                            <a href="javascript:void(0)" (click)="isCollapsed11 = !isCollapsed11"
                              [attr.aria-expanded]="!isCollapsed11" aria-controls="collapseBasic11">Tincidunt ut
                              laoreet dolore magna ?</a>
                            <div id="collapseBasic11" [collapse]="isCollapsed11" [isAnimated]="true"
                              class="collapse in">
                              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                              tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                              quis
                              nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                              consequat.
                            </div>
                          </div>
                        </div> <!-- Question -->

                      </div>

                    </div>
                  </div>
                </div>
              </div> <!-- row end -->
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
